import React from "react";
import { AppBar, Toolbar, Typography } from "@mui/material";
import DocumentationPopup from "./documentation_page"; // Import your DocumentationPopup component

function MyAppBar() {
  return (
    <AppBar position="static" elevation={0}>
      <Toolbar>
        {/* Add your image source in the 'src' attribute */}
        
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          String Localizer v 1.1
        </Typography>
        <DocumentationPopup />
      </Toolbar>
    </AppBar>
  );
}

export default MyAppBar;
